import { Footer } from '../components/Footer'

export function Terms() {
  return (
    <div className="min-h-screen flex flex-col page-content page-container">
      <div className="flex-1 max-w-4xl mx-auto px-4 py-8 w-full">
      <h1 className="text-3xl font-bold mb-6 text-primary">Conditions d'utilisation</h1>
      
      <div className="prose max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Acceptation des conditions</h2>
          <p className="text-secondary">
            En accédant et en utilisant AgentTeamForge Studio, vous acceptez d'être lié par
            les présentes conditions d'utilisation. Si vous n'acceptez pas ces conditions,
            veuillez ne pas utiliser ce service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Utilisation du service</h2>
          <p className="mb-2 text-secondary">Vous vous engagez à :</p>
          <ul className="list-disc list-inside ml-4 space-y-2 text-secondary">
            <li>Utiliser le service de manière légale et conforme à ces conditions</li>
            <li>Ne pas utiliser le service à des fins frauduleuses ou malveillantes</li>
            <li>Ne pas tenter d'accéder à des zones non autorisées du service</li>
            <li>Respecter les droits de propriété intellectuelle</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Compte utilisateur</h2>
          <p className="text-secondary">
            Vous êtes responsable de maintenir la confidentialité de vos identifiants de connexion
            et de toutes les activités qui se produisent sous votre compte. Vous devez nous
            notifier immédiatement de toute utilisation non autorisée de votre compte.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Limitation de responsabilité</h2>
          <p className="text-secondary">
            AgentTeamForge Studio est fourni "tel quel" sans garantie d'aucune sorte. Nous ne
            garantissons pas que le service sera ininterrompu, sécurisé ou exempt d'erreurs.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Modifications</h2>
          <p className="text-secondary">
            Nous nous réservons le droit de modifier ces conditions d'utilisation à tout moment.
            Les modifications entreront en vigueur dès leur publication sur cette page.
          </p>
        </section>
      </div>
      </div>
      <Footer />
    </div>
  )
}

